import React, { useState } from 'react';

// The artwork is drawn at x 19-41 / y 16-43 inside the original 60x60 canvas.
// Cropping the viewBox to those bounds lets the icon be sized like every other
// icon in the toolbars instead of dragging a 60px box around with it.
export default ({ color = '#91A5C6', size = 20 }) => {
  const [isHovered, setHover] = useState(false);
  const fill = isHovered ? '#508AFA' : (color || '#91A5C6');

  return (
    <svg
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      width={size}
      height={size}
      viewBox="18 15 24 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
    <path fillRule="evenodd" clipRule="evenodd" d="M30 16C33.3137 16 36 18.7387 36 22.1171C36 24.9968 34.1841 29.298 30.5523 35.0208C30.5047 35.096 30.4439 35.1607 30.3733 35.2115C30.09 35.4154 29.7125 35.3564 29.4949 35.0868L29.4476 35.0208L29.2276 34.6722L28.801 33.9857L28.3837 33.2986C25.4612 28.4275 24 24.7003 24 22.1171C24 18.7387 26.6863 16 30 16ZM30 18C32.2092 18 34 19.7909 34 22C34 24.2092 32.2092 26 30 26C27.7909 26 26 24.2092 26 22C26 19.7909 27.7909 18 30 18ZM30.0001 20C28.8955 20 28.0001 20.8954 28.0001 22C28.0001 23.1046 28.8955 24 30.0001 24C31.1046 24 32.0001 23.1046 32.0001 22C32.0001 20.8954 31.1046 20 30.0001 20Z" fill={fill}/>
    <path fillRule="evenodd" clipRule="evenodd" d="M25.6282 31.3024L21.2 30L19 40.6364L26 43L34 40L41 41.8182L38.8 31.1818L34.7995 30.4655C34.122 31.8167 33.337 33.2528 32.4444 34.7739L32.8164 38.3079L27.3481 40.3585L28.2369 35.9145L27.845 35.2636C27.0184 33.874 26.2795 32.5536 25.6282 31.3024ZM38.39 39.0739L34.8102 38.1441L34.2046 32.3908L37.1155 32.912L38.39 39.0739ZM22.7187 32.5314L26.6431 33.6856L25.2528 40.6368L21.3171 39.3078L22.7187 32.5314Z" fill={fill}/>
    </svg>
  )
}
